import gql from 'graphql-tag';

export const DeleteLostAndFoundIssue = gql`
  mutation DeleteLostAndFoundIssueBulk($input: DeleteLostAndFoundIssueBulkInput!) {
    deleteLostAndFoundIssueBulk(input: $input) {
      deleted
    }
  }
`;
